"use strict";
'use es6';
/* eslint-disable react/prefer-stateless-function, react/no-multi-comp */

/*
 * This plugin removes the UI for plugins (i.e. buttons and overlays)
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _react = _interopRequireDefault(require("react"));

var _draftExtend = require("draft-extend");

var omitButtonAndOverlayProps = function omitButtonAndOverlayProps(WrappingComponent) {
  return _react.default.createClass({
    blur: function blur() {
      if (this._child.blur) {
        this._child.blur();
      }
    },
    focus: function focus() {
      if (this._child.focus) {
        this._child.focus();
      }
    },
    render: function render() {
      var _this = this;

      var updatedProps = (0, _omit.default)(['buttons', 'overlays'], (0, _immutable.Map)(this.props)).toObject();
      return _react.default.createElement(WrappingComponent, (0, _extends2.default)({
        ref: function ref(c) {
          _this._child = c;
        }
      }, updatedProps));
    }
  });
};

var _default = function _default() {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  return function (WrappingComponent) {
    if (plugins.length === 0) {
      return WrappingComponent;
    }

    if (WrappingComponent.prototype && WrappingComponent.prototype.isReactComponent) {
      return _draftExtend.compose.apply(void 0, plugins.concat([omitButtonAndOverlayProps]))(WrappingComponent);
    } // not an Editor component, so accumulate as usual


    return _draftExtend.compose.apply(void 0, plugins)(WrappingComponent);
  };
};

exports.default = _default;
module.exports = exports.default;